import React from "react";
import { useSetState } from "components/ReduxProvider";
import { useMount } from "react-use";
import { getVolume, isVolumePluginAvailable } from "tools/volume";

const Volume: React.FC = () => {
  const setVolume = useSetState("volume");

  useMount(() => {
    const initializeVolume = async () => {
      const currentVolume = await getVolume();
      setVolume(currentVolume ?? undefined);
    };

    initializeVolume();

    if (isVolumePluginAvailable()) {
      window.plugin?.volume?.setVolumeChangeCallback((volume: number) => {
        setVolume(volume);
      });
    }
  });

  return null;
};

export default Volume;
